module.exports = ".tool_button {\r\n  float: right;\r\n  margin-right:50px;\r\n}\r\n\r\n.message {\r\n  margin-top:50px;\r\n}\r\n\r\n.contract-form {\r\n  margin-top: 40px;\r\n  min-width: 150px;\r\n  max-width: 100%;\r\n  width: 100%;\r\n  font-size: 12px;\r\n}\r\n\r\n.field-width {\r\n  width: 100%;\r\n}\r\n\r\n.grid-title{\r\n  text-align:center;\r\n  font-size: 12px;\r\n  font-weight: bold;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/contract/popup-contract.component.css
// module id = ./src/app/contract/popup-contract.component.css
// module chunks = main